import { useRef, useState } from "react";

const ADSET_MIN_WIDTH = 140;
const ADSET_MAX_WIDTH = 1020;
const ADSET_DEFAULT_WIDTH = 260;
const ADSET_WIDTH_KEY = "ams:adRequestTable:adsetWidth";

const readStoredAdsetWidth = () => {
  try {
    const saved = Number(window.localStorage.getItem(ADSET_WIDTH_KEY));
    if (!Number.isFinite(saved) || saved <= 0) return ADSET_DEFAULT_WIDTH;
    return Math.min(ADSET_MAX_WIDTH, Math.max(ADSET_MIN_WIDTH, saved));
  } catch {
    return ADSET_DEFAULT_WIDTH;
  }
};

/** Drag-resizable Ad Set column width, remembered in localStorage. */
export default function useAdsetColumnWidth() {
  const [adsetWidth, setAdsetWidth] = useState(readStoredAdsetWidth);
  const adsetWidthRef = useRef(adsetWidth);

  const startAdsetResize = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const startX = e.clientX;
    const startWidth = adsetWidthRef.current;
    const onMove = (ev) => {
      const next = Math.min(
        ADSET_MAX_WIDTH,
        Math.max(ADSET_MIN_WIDTH, startWidth + ev.clientX - startX)
      );
      adsetWidthRef.current = next;
      setAdsetWidth(next);
    };
    const onUp = () => {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
      document.body.style.userSelect = "";
      try {
        window.localStorage.setItem(
          ADSET_WIDTH_KEY,
          String(adsetWidthRef.current)
        );
      } catch {}
    };
    document.body.style.userSelect = "none";
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
  };

  return { adsetWidth, startAdsetResize };
}
